<template>
  <div _w="100%">
    <div _w="100%" _flex="~" v-if="loading">
      <div _w="360px" _h="360px" _pos="relative">
        <cropper-canvas background >
          <cropper-image :src="src" ref="cropperimage" alt="Picture" rotatable scalable skewable translatable crossorigin="anonymous"></cropper-image>
          <cropper-shade hidden></cropper-shade>
          <cropper-handle action="select" plain></cropper-handle>
          <cropper-selection id="cropperSelection" ref="cropperselection" initial-aspect-ratio="1" initial-coverage="0.8" movable resizable>
            <cropper-crosshair centered></cropper-crosshair>
            <cropper-handle action="move" plain></cropper-handle>
            <cropper-handle action="n-resize"></cropper-handle>
            <cropper-handle action="e-resize"></cropper-handle>
            <cropper-handle action="s-resize"></cropper-handle>
            <cropper-handle action="w-resize"></cropper-handle>
            <cropper-handle action="ne-resize"></cropper-handle>
            <cropper-handle action="nw-resize"></cropper-handle>
            <cropper-handle action="se-resize"></cropper-handle>
            <cropper-handle action="sw-resize"></cropper-handle>
          </cropper-selection>
        </cropper-canvas>
        <div _text="[#FFFFFF]" _m="t-[-42px]" _flex="~ justify-center">
          <span class="img_btn" _m="r-15px" @click="handleRotate">
            <img :src="require('@/assets/image/img_rotate.png')" _w="20px" _m="r-5px">旋转
          </span>
          <span class="img_btn" @click="handleRest">
            <img :src="require('@/assets/image/img_rest.png')" _w="20px" _m="r-5px">还原
          </span>
        </div>
      </div>
      <div class="cropper-viewers" _m="l-15px t-20px" v>
        <div _text="[#3B3B3B] 18px bolder" _m="b-20px">预览</div>
        <cropper-viewer
          selection="#cropperSelection"
          style="width: 200px;height:200px;overflow:hidden"
          _border="rounded-[100%]"
        ></cropper-viewer>
      </div>
    </div>
    <div v-else _w="360px" _h="360px"></div>
  </div>
</template>
<script>
import 'cropperjs';
import { httpRequest } from '../ResourceManagement/UploadEvent'
export default {
  props: {
    src: String,
    successCallback: Function
  },
	data() {
    return {
      loading: false
    }
  },
  methods: {
    // 旋转
    handleRotate() {
      this.$refs.cropperimage.$rotate('90deg')
      this.$refs.cropperimage.$center('contain')
    },
    // 还原
    async handleRest() {
      this.loading = false
      await new Promise(resolve => setTimeout(resolve, 100))
      this.loading = true
    },
    // 裁剪
    async handleConfirm() {
      const res = await this.$refs.cropperselection.$toCanvas()
      const circularCanvas = document.createElement('canvas')
      const context = circularCanvas.getContext('2d')
      const size = Math.min(res.width, res.height)
      circularCanvas.width = size
      circularCanvas.height = size
      context.beginPath()
      context.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2)
      context.closePath()
      context.clip()
      context.drawImage(res, 0, 0, size, size);
      const dataImage = circularCanvas.toDataURL('image/png', 1)
      const file = this.dataURLtoFile(dataImage, '圆形裁剪');
      const uri = await this.uploadFile(file)
      this.successCallback && this.successCallback(uri)
      return uri
    },
    // 二进制转换
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const blob = new Blob([u8arr], { type: mime });
      const file = new File([blob], filename, { type: mime });
      return file;
    },
    // 上传
    async uploadFile(file) {
      const { uri, node } = await httpRequest(file, this.$api3.question_set.upload)
      return { uri, node }
    }
  },
  watch: {
    src: {
      handler(newVal) {
        if (newVal) {
          this.handleRest()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.loading = true
    this.handleRest()
  },
  beforeDestroy() {
  }
}
</script>
<style lang="scss" scoped>
:deep(cropper-canvas) {
  width: 100%;
  height: 100%;
}
:deep(cropper-shade) {
  --theme-color: rgba(0, 0, 0, 0.45);
  border-radius: 100%;
}
:deep(cropper-handle[action*="resize"]) {
  --theme-color: #ff5e2a;
}
.img_btn {
  background: rgba(45,45,45,0.9);
  color: #FFFFFF;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 30px;
  z-index: 99;
  font-size: 16px;
  cursor: pointer;
  font-weight: 600;
}
</style>
